import { get, post, del, put, upload } from '@api/request';

export const fetchQueues = async ({ queueService }, authenticationToken) => {
  const url = `${queueService}/queue/queues`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addQueue = async (
  { queueService },
  authenticationToken,
  payload,
) => {
  const url = `${queueService}/queue/queues`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteQueue = async (
  { queueService },
  authenticationToken,
  { queueID },
) => {
  const url = `${queueService}/queue/queue/${queueID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchQueue = async (
  { queueService },
  authenticationToken,
  { queueID },
) => {
  const url = `${queueService}/queue/queue/${queueID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateQueue = async (
  { queueService },
  authenticationToken,
  { queueID, payload },
) => {
  const url = `${queueService}/queue/queue/${queueID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchQueueUsers = async (
  { queueService },
  authenticationToken,
  { queueID },
) => {
  const url = `${queueService}/queue/queue/${queueID}/users`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addQueueUser = async (
  { queueService },
  authenticationToken,
  { queueID, payload },
) => {
  const url = `${queueService}/queue/queue/${queueID}/users`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteQueueUser = async (
  { queueService },
  authenticationToken,
  { queueUserID },
) => {
  const url = `${queueService}/queue/queueuser/${queueUserID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchQueueUser = async (
  { queueService },
  authenticationToken,
  { queueUserID },
) => {
  const url = `${queueService}/queue/queueuser/${queueUserID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateQueueUser = async (
  { queueService },
  authenticationToken,
  { queueUserID, payload },
) => {
  const url = `${queueService}/queue/queueuser/${queueUserID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export async function fetchAllUsers({ userService }, authenticationToken) {
  const url = `${userService}/trueprodigy/userlisting?userType=internal`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export const fetchQueueWorkItems = async (
  { queueService },
  authenticationToken,
  { queueID, submittedOnly },
) => {
  const url = `${queueService}/queue/queue/${queueID}/workitems?submittedOnly=${submittedOnly}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchQueueWorkItem = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateQueueWorkItem = async (
  { queueService },
  authenticationToken,
  { workitemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchWorkItemAttachments = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/fileattachments`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addWorkItemAttachment = async (
  { queueService },
  authenticationToken,
  { workitemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/fileattachments`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const downloadWorkItemAttachment = async (
  { queueService },
  authenticationToken,
  { workItemFileAttachmentID, s3ID },
) => {
  const url = `${queueService}/queue/workitem/fileattachment/${workItemFileAttachmentID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = s3ID ? s3ID : workItemFileAttachmentID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const deleteWorkItemAttachment = async (
  { queueService },
  authenticationToken,
  { workItemFileAttachmentID },
) => {
  const url = `${queueService}/queue/workitem/fileattachment/${workItemFileAttachmentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchWorkItemProperties = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/properties`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addWorkItemProperty = async (
  { queueService },
  authenticationToken,
  { workitemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/properties`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteWorkItemProperty = async (
  { queueService },
  authenticationToken,
  { workItemPropID },
) => {
  const url = `${queueService}/queue/workitem/property/${workItemPropID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchWorkItemDeeds = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/deeds`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addWorkItemDeed = async (
  { queueService },
  authenticationToken,
  { workitemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/deeds`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteWorkItemDeed = async (
  { queueService },
  authenticationToken,
  { workItemDeedID },
) => {
  const url = `${queueService}/queue/workitem/deed/${workItemDeedID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchWorkItemAppeals = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/appeals`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addWorkItemAppeal = async (
  { queueService },
  authenticationToken,
  { workitemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/appeals`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteWorkItemAppeal = async (
  { queueService },
  authenticationToken,
  { workItemAppealID },
) => {
  const url = `${queueService}/queue/workitem/appeal/${workItemAppealID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchWorkItemEvents = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/events`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addWorkItemEvent = async (
  { queueService },
  authenticationToken,
  { workitemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/events`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteWorkItemEvent = async (
  { queueService },
  authenticationToken,
  { workItemEventID },
) => {
  const url = `${queueService}/queue/workitem/event/${workItemEventID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const fetchWorkItemBuildingPermits = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/buildingpermits`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const addWorkItemBuildingPermit = async (
  { queueService },
  authenticationToken,
  { workitemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/buildingpermits`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteWorkItemBuildingPermit = async (
  { queueService },
  authenticationToken,
  { workItemPermitID },
) => {
  const url = `${queueService}/queue/workitem/buildingpermit/${workItemPermitID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const changeWorkItemOrder = async (
  { queueService },
  authenticationToken,
  { queueID, workItemID, payload },
) => {
  const url = `${queueService}/queue/queue/${queueID}/workitem/${workItemID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const moveWorkItems = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/workitems/move`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const finalizeWorkItem = async (
  { queueService },
  authenticationToken,
  { workItemID },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/finalize`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const reopenWorkItem = async (
  { queueService },
  authenticationToken,
  { workItemID },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/reopen`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const fetchQueueStatistics = async (
  { queueService },
  authenticationToken,
  { queueID, payload },
) => {
  const url = `${queueService}/queue/queue/${queueID}/statistics`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchQueueHistories = async (
  { queueService },
  authenticationToken,
  { workItemID },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/queuehistory`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchStatusHistories = async (
  { queueService },
  authenticationToken,
  { workItemID },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/statushistory`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const shareVirtualRoom = async (
  { queueService },
  authenticationToken,
  { workItemID },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/sharevirtualroom`;
  const { body } = await post(authenticationToken, url);
  return body;
};

export const massUpdateStatus = async (
  { queueService },
  authenticationToken,
  { payload },
) => {
  const url = `${queueService}/queue/workitems/updatestatuses`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchQueueFirstWorkItem = async (
  { queueService },
  authenticationToken,
  { queueID },
) => {
  const url = `${queueService}/queue/queue/${queueID}/firstitem`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const checkWorkItemEditable = async (
  { queueService },
  authenticationToken,
  { workitemID },
) => {
  const url = `${queueService}/queue/workitem/${workitemID}/editablebyuser`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCopyFinalizedWorkItemRuns = async (
  { queueService },
  authenticationToken,
  { page = 0, pageSize = 100 }
) => {
  const url = `${queueService}/queue/workitem/copyattachmentstoproperty?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchCopyFinalizedWorkItemRunWorkItems = async (
  { queueService },
  authenticationToken,
  { runID, page = 0, pageSize = 100 }
) => {
  const url = `${queueService}/queue/workitem/copyattachmentstoproperty/${runID}/workitems?page=${page}&pageSize=${pageSize}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const startCopyFinalizedWorkItemRun = async (
  { queueService },
  authenticationToken,
  { payload }
) => {
  const url = `${queueService}/queue/workitem/copyattachmentstoproperty`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertWorkItemNotes = async (
  { queueService },
  authenticationToken,
  { workItemID, payload },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/notes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchWorkItemNotes = async (
  { queueService },
  authenticationToken,
  { workItemID },
) => {
  const url = `${queueService}/queue/workitem/${workItemID}/notes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchWorkItemNote = async (
  { queueService },
  authenticationToken,
  { workItemNoteID },
) => {
  const url = `${queueService}/queue/workitem/note/${workItemNoteID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateWorkItemNote = async (
  { queueService },
  authenticationToken,
  { workItemNoteID, payload },
) => {
  const url = `${queueService}/queue/workitem/note/${workItemNoteID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteWorkItemNote = async (
  { queueService },
  authenticationToken,
  { workItemNoteID },
) => {
  const url = `${queueService}/queue/workitem/note/${workItemNoteID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};